import Vue from 'vue'
import App from './App.vue'

import './styles/quasar.styl'
import 'quasar-extras/material-icons'
import 'quasar-extras/fontawesome'
import 'quasar-extras/ionicons'
import 'quasar-extras/mdi'
import Quasar from 'quasar'

Vue.use(Quasar, {
    config: {}
})

Vue.config.productionTip = false

// Роутинг
import VueRouter from 'vue-router'
import AuthPage from './pages/Authorization.vue';
import ExitLK from './pages/ExitLK.vue';
import Settings from './pages/Profile.vue';
import Reg from './pages/Registration.vue';
import Devices from './pages/Devices.vue';

const router = new VueRouter({
    routes: [
        { path: '/auth', component: AuthPage },
        { path: '/reg', component: Reg },
        { path: '/settings', component: Settings },
        { path: '/devices', component: Devices },
        { path: '/exit', component: ExitLK },
    ]
})
Vue.use(VueRouter)

// Локальное хранилище данных
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)
const store = new Vuex.Store({
    state: {
        lang: 'ru',
        token: '',
        is_auth: false,
        name: ''
    },
    plugins: [createPersistedState()],
    mutations: {
        set_token: (state, data) => {
            state.token = data.token;
        },
        unset_token: (state) => {
            state.token = '';
        },
        set_lang: (state, data) => {
            state.lang = data
        },
        unset_lang: (state) => {
            state.lang = 'ru'
        },
        set_name: (state, data) => {
            state.name = data;
        },
        unset_name: (state) => {
            state.name = '';
        },
        set_auth: (state) => {
            state.is_auth = true;
        },
        unset_auth: (state) => {
            state.is_auth = false;
        },

    }
})

// Поддержка мультиязычности
import VueInternalization from 'vue-i18n'
Vue.use(VueInternalization)
import messages from './i18n/ru.js'
const i18n = new VueInternalization({
    locale: store.state.lang,
    messages,
})
Vue.config.lang = 'ru';

// Подключение валидатора
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

// Фильтры
Vue.filter('dateformat', function(value) {
    if (!value) return ' - '
    return Intl.DateTimeFormat('ru-RU').format(new Date(value))
});

Vue.filter('datetimeformat', function(value) {
    if (!value) return ' - '
    let options = {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
    };
    return Intl.DateTimeFormat('ru-RU', options).format(new Date(value))
});

Vue.filter('romanformat', function(value) {
    if (!value) return ' - '
    switch (value) {
        case 1:
            return i18n.messages[store.state.lang].programm + ' I';
        case 2:
            return i18n.messages[store.state.lang].programm + ' II';
        case 3:
            return i18n.messages[store.state.lang].programm + ' III';
        case 4:
            return i18n.messages[store.state.lang].programm + ' IV';
        case 5:
            return i18n.messages[store.state.lang].programm + ' V';
        case 6:
            return i18n.messages[store.state.lang].programm + ' VI';
        case '-':
            return i18n.messages[store.state.lang].nonselect;
    }
});

Vue.filter('truncate', function(value, len, filler) {
    if (!value) return ' - '
    if (value.length <= len) return value
    return value.substring(0, len) + filler
});



// Создание базового компонента 
new Vue({
    i18n,
    data: {
        api_url: window.location.origin + '/api/',
        //api_url: 'https://osteon-test.iotex.biz/api/',
    },
    router: router,
    store: store,
    render: createEle => createEle(App)
}).$mount('#app')